'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Converse = require('../Converse');

var _Converse2 = _interopRequireDefault(_Converse);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _hidden = require('./styled/hidden');

var _hidden2 = _interopRequireDefault(_hidden);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hidden = function Hidden(props) {
  return _react2.default.createElement(_hidden2.default, (0, _extends3.default)({}, props, {
    value: Hidden.rewriteValue(props.value, props.formStore.values),
    type: 'hidden'
  }));
};

/**
 * ~financial_amount_monthly_suggestion|0| + financial_amount_monthly|0| + financial_amount_yearly_suggestion|0| + financial_amount_yearly|0|~
 * @param value
 * @param values
 * @returns {*}
 */


// styled
Hidden.rewriteValue = function (value, values) {
  if (!value || !value.toString().startsWith('~') || !value.toString().endsWith('~')) return value;
  return _Converse2.default.calculateFormula(values, value.slice(1, -1));
};

Hidden.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.number.isRequired]).isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired
};

var DecoratedHidden = (0, _mobxReact.observer)(Hidden);

DecoratedHidden.meta = {
  wrapper: 'div',
  wrapperProps: { style: { display: 'none' } }
};

DecoratedHidden.rewriteValue = Hidden.rewriteValue;

exports.default = DecoratedHidden;